import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';
import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';
import { CategoryService } from '@app/core/products/services/category.service';
import { SubCategoryService } from '@app/core/products/services/subcategory.service';
import { ProductDesignService } from '@app/core/quotes/services/product-design.service';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { StaffService } from '@app/core/staff';
import { environment } from '@app/env-service';
import { UIStateService } from '@app/shared/services/ui-state.service';
import { trimWala } from '@app/shared/utils/string.utils';

import { NdBulkUpdatePopupFormComponent } from '../nd-bulk-update-popup-form/nd-bulk-update-popup-form.component';
import { NdPipelinePopupComponent } from '../nd-pipeline-popup/nd-pipeline-popup.component';
import { NdPopupFormComponent } from '../nd-popup-form/nd-popup-form.component';
import { NdViewCardPopupComponent } from '../nd-view-card-popup/nd-view-card-popup.component';

@Component({
  selector: 'cnc-nd-list-view',
  templateUrl: './nd-list-view.component.html',
  styleUrls: ['./nd-list-view.component.scss'],
})
export class NdListViewComponent implements OnInit, OnDestroy {
  url :string = environment.url;

  productDesigns :any = { data: [] };
  pageSizeOptions :number[] = [5, 10, 25, 100];

  filter :any = {};
  params :any = {
    per_page: 20,
    page: 1,
  };

  designSubscription :Subscription;

  pdSubs :Subscription;
  checked :any = [];
  showFilter :boolean = false;
  checkedAll :boolean = false;
  checkedCount :number = 0;

  priority :any = {
    '10': 'Low',
    '20': 'Medium',
    '30': 'High',
  };

  columns :any = [
    { key: 'created_at', show: true, label: 'Date Created', sortable: true },
    { key: 'due_date', show: true, label: 'Due Date', sortable: true },
    { key: 'id', show: true, label: 'Reference ID', sortable: true },
    // { key: 'reference_id', show: true, label: 'Reference ID', sortable: true },
    { key: 'design_name', show: true, label: 'Task Name', sortable: true },
    { key: 'description', show: true, label: 'Description', sortable: false },
    { key: 'links', show: true, label: 'Links', sortable: false },
    { key: 'attachments', show: true, label: 'Attachments', sortable: false },
    { key: 'assignees', show: true, label: 'Assignees', sortable: false },
    { key: 'pipeline', show: true, label: 'Pipeline', sortable: false },
    {
      key: 'assigned_subtasks',
      show: true,
      label: 'Subtasks',
      sortable: false,
    },
  ];

  columnsCopy :any;

  designPipelines :any = [];

  column_settings :any;

  constructor(
    public authService :AuthService,
    public productDesignSvc :ProductDesignService,
    private cd :ChangeDetectorRef,
    private modal :NgbModal,
    private router :Router,
    private translate :TranslateService,
    private toastr :ToastrService,
    public staffSvc :StaffService,
    public tagSvc :ProductTagService,
    public pipelineSvc :PipelineService,
    private uiStateSvc :UIStateService,
    private activeRoute :ActivatedRoute,
    public subcategorySvc :SubCategoryService,
    public pcatService :CategoryService,
    private settingsSvc :SettingsService,
  ) {}

  ngOnInit() {
    this.settingsSvc.getProjectManagementSettings().subscribe((resp :any) => {
      const { settings, columns } = resp;

      this.columns = columns;

      if (settings && settings.id) {
        const settingsValue = JSON.parse(settings.value);

        if (!settingsValue.column_settings) {
          this.column_settings = columns.reduce((acc, curr) => {
            return {
              ...acc,
              [curr.key]: { label: curr.label, is_required: 0 },
            };
          }, {});
        } else {
          this.column_settings = settingsValue.column_settings;
        }
      }
    });

    this.columnsCopy = JSON.parse(JSON.stringify(this.columns));
    const stateView = this.uiStateSvc.getState('design-list-view-columns');
    if (stateView) {
      const columnKeys = this.columns.map((e) => e.key);
      const stateColumnKeys = stateView.map((e) => e.key);
      const found = columnKeys.every((r) => stateColumnKeys.includes(r));

      if (found) {
        this.columns = stateView;
      }
    }

    this.getRecords();

    this.tagSvc.getTags({ parent_only: true }, null);

    this.pdSubs = this.productDesignSvc.productDesigns$.subscribe((records) => {
      this.productDesigns = records;
      this.cd.detectChanges();
    });

    this.designSubscription = this.activeRoute.params.subscribe((params) => {
      if (!params || !params.id) {
        return;
      }
      this.productDesignSvc.getById(params.id).subscribe((resp) => {
        if (resp && resp.id) {
          if (resp.status > 0) {
            const modalRef = this.modal.open(NdViewCardPopupComponent, {
              size: 'lg',
            });
            modalRef.componentInstance.designCard = resp;
            modalRef.componentInstance.tabIndex = 0;
          } else {
            this.toastr.error('Card already deleted.', 'Error');
            this.router.navigate(['/quotes/new-designs'], { replaceUrl: true });
            // this.location.replaceState("/quotes/new-designs/");
          }
        }
        this.cd.detectChanges();
      });
    });
  }

  checkAll() {
    if (!this.checkedAll) {
      this.checked = [];
      this.countChecked();

      return;
    }

    this.productDesignSvc.productDesigns$.subscribe((records) => {
      records.data.forEach((r) => {
        this.checked[r.id] = this.checkedAll;
      });
      this.countChecked();
      this.cd.detectChanges();
    });

    console.log('check cnt', this.checked);
  }

  editdesign(design :any) {
    // this.router.navigateByUrl('/quotes/new-designs/' + design.id.toString() + '/update');
    const modalRef = this.modal.open(NdPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.design = design;
  }

  getRecords(event ?:any, page ?:number) {
    if (page) {
      this.params.page = page;
    }

    this.params = Object.assign(this.params, this.filter);
    this.params = Object.entries(this.params).reduce(
      (a, [k, v]) => (v ? ((a[k] = v), a) : a),
      {},
    ); // remove falsy filter values

    if (this.filter.assigned_tags && this.filter.assigned_tags.length > 0) {
      this.params.assigned_tags = this.filter.assigned_tags.join(',');
    } else {
      delete this.params.assigned_tags;
    }

    if (this.filter.category_id && this.filter.category_id.length > 0) {
      this.params.category_id = this.filter.category_id.join(',');
    } else {
      delete this.params.category_id;
    }

    if (this.filter.subcategory_id && this.filter.subcategory_id.length > 0) {
      this.params.subcategory_id = this.filter.subcategory_id.join(',');
    } else {
      delete this.params.subcategory_id;
    }

    if (this.params.order) {
      this.params.order = trimWala(this.params.order, '-');
    }

    if (event) {
      this.params.page = event.pageIndex + 1;
      this.params.per_page = event.pageSize;
    }
    // set state
    this.productDesignSvc.get(this.params);
    this.pcatService.getProductCategories();
    this.subcategorySvc.get();
  }

  deletedesign(design :any) {
    Swal.fire({
      title: 'Confirm delete?',
      text: "Delete design '" + design.design_name + "'?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        this.productDesignSvc
          .deleteproductDesign(design.id)
          .subscribe((resp :any) => {
            this.toastr.success('Successfully deleted design.', 'Success');
          });
      }
    });
  }

  ngOnDestroy() {
    this.pdSubs.unsubscribe();
    this.designSubscription.unsubscribe();
  }

  resetFilters() {
    this.filter = {};
    this.params = {
      per_page: 20,
      page: 1,
    };
    delete this.params.title;
    this.getRecords();
  }

  addToPipelines() {
    const designs :any = this.productDesigns.data.filter(
      (row) => !(typeof this.checked[row.id] === 'undefined'),
    );
    if (designs.length <= 0) {
      return;
    }
    const modalRef = this.modal.open(NdPipelinePopupComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.designs = designs.map((row) => {
      return { id: row.id, name: row.design_name, sku: row.sku };
    });
    // modalRef.componentInstance.moveRfqToPipeline = 1;
  }

  addToPipeline(design :any) {
    const modalRef = this.modal.open(NdPipelinePopupComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.design = design;
    // modalRef.componentInstance.moveRfqToPipeline = 1;
  }

  setOrder(order :string) {
    if (this.filter.order && this.filter.order == order) {
      this.filter.order = '-' + order;
      this.filter.sort = 'desc';
    } else {
      this.filter.order = order;
      this.filter.sort = 'asc';
    }

    this.getRecords();
  }

  customTagsSearchFn(term :any, item :any) {
    term = term.toLocaleLowerCase();

    return item.name
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
  }

  getRecordTimeout() {
    setTimeout(() => {
      this.getRecords(false, 1);
    }, 10);
  }

  abilityToDelete(design) {
    if (this.authService.loginUser.role == 99) {
      return true;
    }
    if (design.created_by == null) {
      return false;
    }
    if (design.created_by.id == this.authService.loginUser.id) {
      return true;
    } else {
      return false;
    }
  }

  getDescriptionLength(string :any) {
    return (
      string
        ? string
            .replace(/<.*?>/g, '') // replace html tags
            .replace(/&.*?;/g, '') // replace symbols
        : ''
    ).length;
  }

  getColumnProperty(key :string) {
    let obj = this.columns.find((col) => col.key === key);
    if (!obj) {
      obj = this.columnsCopy.find((col) => col.key === key);
    }

    return obj;
  }

  getColumnsCount() {
    return this.columns.filter((col) => col.show).length;
  }

  updateTableColumns(index :number) {
    this.columns[index].show = !this.columns[index].show;
    this.uiStateSvc.setState('design-list-view-columns', this.columns);
  }

  showDetails(design :any, index :number, tabIndex :number = 0) {
    // this.router.navigate(["/quotes", "new-designs", design.id, "view"]);
    const modalRef = this.modal.open(NdViewCardPopupComponent, { size: 'lg' });
    modalRef.componentInstance.designCard = design;
    modalRef.componentInstance.tabIndex = tabIndex;

    modalRef.result.then(
      (newDesign :any) => {
        if (newDesign && newDesign.id) {
          // const stage = this.activePipeline.stages[i];
          // const idx = stage.records.findIndex((row) => row.id == newDesign.id);
          // stage.records.splice(idx, 1, Object.assign(stage.records[idx], newDesign));
          // this.ref.detectChanges();
        }
      },
      (_) => {},
    );

    // window.open('/quotes/new-designs/' + design.id + '/view');
  }

  getSubtasksStatusCount(subtasks :any) {
    const completed = subtasks.filter((e) => e.done).length;
    const subtasks_count = subtasks.length;

    return completed + '/' + subtasks_count;
  }

  countChecked() {
    this.checkedCount = this.checked.filter((x) => {
      return x;
    }).length;
  }

  updateSelected() {
    const ids = [];
    this.checked.forEach((v, idx) => {
      if (v) {
        ids.push(idx);
      }
    });

    const modalRef = this.modal.open(NdBulkUpdatePopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.ids = ids;

    // to do: pass selected ids
  }
}
